import { OverlayShellConfig } from "../../../shared/overlay-shell/overlay.models";

export const NEW_DOCUMENTS_OVERLAY_CONFIG: OverlayShellConfig = {
  resizable: false,
  width: "auto",
  height: "auto",
};
